module.exports = __webpack_public_path__ + "img/nav-back.a680c546.png";